module.exports = __webpack_public_path__ + "static/media/location-stale-marker.min.e12fe4be.svg";